<!-- Idea Modal Header Start-->
<div class="modal-header cluster-manager-modal">
  <button
    type="button"
    (click)="close()"
    class="btn-close"
    title="Close"></button>
</div>
<!-- Idea Modal Header End-->

<!-- Idea Modal Body Start-->
<div class="modal-body idea-modal clearfix external-document-modal">
  <div class="row content">
    <div class="title col-lg-12">
      <div class="h1">{{ title }}</div>
    </div>
    <div class="pictures col-lg-12">
      <ng-container *ngFor="let pictureUrl of pictureUrls">
        <img alt [src]="pictureUrl" />
      </ng-container>
    </div>
    <div class="text col-lg-12 text-container">
      <span class="">{{ text }}</span>
    </div>
    <div class="keywords col-lg-12">
      <b>Keywords:</b>
      <span>{{ getKeywordString() }}</span>
    </div>
  </div>
</div>
<!-- Idea Modal Body End-->

<div class="modal-footer">
  <div class="btn btn-secondary" (click)="close()">Cancel</div>
</div>
